import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GlobalPopup from "./GlobalPopup.js";
import { closeGlobalPopup } from "../../redux/action.js";
import "./ConfirmBox.css";

const ConfirmBox = ({ title, onConfirm, onCancel = () => { }, closeOnConfirm = false, variant = "default" }) => {
    const dispatch = useDispatch();
    const deleteSaving = useSelector((state) => Boolean(state.admin?.deleteSaving));
    const isDeleting = variant === "delete" && deleteSaving;
    const confirmLock = useRef(false);

    useEffect(() => {
        if (!isDeleting) {
            confirmLock.current = false;
        }
    }, [isDeleting]);

    const handleConfirm = () => {
        if (isDeleting || confirmLock.current) return;
        if (variant === "delete") confirmLock.current = true;

        if (onConfirm) {
            onConfirm();
        }
        if (closeOnConfirm && variant !== "delete") {
            dispatch(closeGlobalPopup());
        }
    };

    const handleCancel = () => {
        if (isDeleting) return;
        if (onCancel) {
            onCancel();
        }
        dispatch(closeGlobalPopup());
    };

    return (
        <GlobalPopup
            popupKey="confirm-box"
            title={title}
            hideCloseButton={variant === "delete"}
            disableClose={isDeleting}
        >
            <div className="confirm-box">
                <button className="confirm-btn" onClick={handleConfirm} disabled={isDeleting} aria-busy={isDeleting}>
                    {isDeleting && <span className="popup-button-spinner" aria-hidden="true" />}
                    {isDeleting ? "Deleting..." : "Confirm"}
                </button>
                <button className="cancel-btn-2" onClick={handleCancel} disabled={isDeleting}>Cancel</button>
            </div>
        </GlobalPopup>
    );
}

export default ConfirmBox;
